export default {
  governments: [],
  regions: [],
  governments_success: "",
  regions_success: "",
  errors: [],
  error_msg: "",
};
